import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, Field, SubmissionError } from 'redux-form'
import { Button } from 'semantic-ui-react'
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { WithholdingFormContainer } from './styled'
import { getWhtTypes, getWhtReceiptTypes } from 'ducks/options'
// import r from 'reactotron-react-js'

const WithholdingTaxModal = (props) => {
  const { valueForm, handleSubmit, onSubmitWithholdingTax, showWhtModal, whtTaxData, clearWhtTaxData, listWht, whtTypes, whtReceiptTypes } = props
  const isNew = whtTaxData ? false : true

  React.useEffect(() => {
    if (!whtTypes.data.length && !whtTypes.loading) {
      props.getWhtTypes()
    }

    if (!whtReceiptTypes.data.length && !whtReceiptTypes.loading) {
      props.getWhtReceiptTypes()
    }
  }, [])

  const submitWithholdingTax = () => {
    var whtTypeIsDuplicate = false
    if (isNew) {
      var w = listWht.find(x => x.whtTypeCode === valueForm.whtTypeCode)

      if (w) whtTypeIsDuplicate = true
    } else {
      if (whtTaxData.whtTypeCode !== valueForm.whtTypeCode) {
        // Change WHT type
        var wht = listWht.find(x => x.whtTypeCode === valueForm.whtTypeCode)
        if (wht) whtTypeIsDuplicate = true
      }
    }

    if (!whtTypeIsDuplicate) {
      onSubmitWithholdingTax(valueForm, isNew, whtTaxData)
      if (!isNew) clearWhtTaxData()
      showWhtModal(false)
    } else {
      throw new SubmissionError({ whtTypeCode: 'This withholding tax type is duplicate!' })
    }
  }

  const whtTaxReceiptTypeOptions = () => {
    const receiptTypes = whtReceiptTypes.data.filter(x => x.withholdingTaxTypeCode === valueForm.whtTypeCode) || []
    return receiptTypes
  }

  return (
    <Dialog open={true} className='dialog-full-height' maxWidth='sm' fullWidth style={{ zIndex: 10 }}>
      <DialogTitle>Withholding Tax</DialogTitle>
      <DialogContent style={{ height: 'fit-content' }}>
        <form>
          <WithholdingFormContainer>
            <div className='rowFields'>
              <Field 
                name='whtTypeCode' 
                label='Withholding Tax Type' 
                require
                loading={whtTypes.loading}
                options={whtTypes.data}
                type={type.select} 
                component={FieldInput} 
              />
              <Field 
                name='whtReceiptTypes' 
                label='Receipt Type' 
                require
                loading={whtReceiptTypes.loading}
                options={whtTaxReceiptTypeOptions()}
                type={type.select} 
                component={FieldInput} 
              />
            </div>
            <div className='rowFields'>
              <Field name='subject' label='Subject' require type={type.checkbox} component={FieldInput} />
            </div>
            {/* <div className='rowFields'>
              <div style={{ height: '12rem' }} />
            </div> */}
          </WithholdingFormContainer>
        </form>
      </DialogContent>
      <DialogActions>
        <form onSubmit={handleSubmit(values => submitWithholdingTax())}>
          <Button
            color='blue'
            content={isNew ? 'Add' : 'Save'}
            type='submit'
          />
          <Button
            color='red'
            content='Cancel'
            onClick={() => {
              clearWhtTaxData()
              showWhtModal(false)
            }}
          />
        </form>
      </DialogActions>
    </Dialog>
  )
}

const mapStateToProps = (state, props) => {
  const whtTaxData = props.whtTaxData || {}
  return ({
    valueForm: getFormValues('formWithholdingTax')(state) || {},
    initialValues: {
      id: whtTaxData.id || null,
      whtTypeCode: whtTaxData.whtTypeCode || '',
      whtReceiptTypes: whtTaxData.whtReceiptTypes || '',
      subject: whtTaxData.subject || ''
    },
    whtTypes: state.options.whtTypes,
    whtReceiptTypes: state.options.whtReceiptTypes,
  })
}
  
const mapDispatchToProps = {
  getWhtTypes, 
  getWhtReceiptTypes
}

const validate = (values) => {
  const errors = {}
  if (!values.whtTypeCode) errors.typeCode = 'Require!'
  if (!values.receiptTypeCode) errors.receiptTypeCode = 'Require!'

  return errors
}

const WithholdingTaxForm = reduxForm({
  form: 'formWithholdingTax',
  enableReinitialize: true,
  validate
})(WithholdingTaxModal)

export default connect(mapStateToProps, mapDispatchToProps)(WithholdingTaxForm)